var navInit;

(function ($) {

	const selectors = {
		navContainer: '.c-nav',
	}

	navInit = function () {
		$(selectors.navContainer).each((i, el) => {
			new Nav(el);
		});
	}

	class Nav {
		constructor(element) {
			this.$container = $(element);

			this.init();
			this.bind();

		}
		init() {
			this.$items = $(this.$container).children('li')
		}

		bind() {
			const self = this;
			this.onHover = this.onHover.bind(this);
			this.onHoverOut = this.onHoverOut.bind(this);
			this.$items.hover(function (e) { self.onHover(this); }, function (e) { self.onHoverOut(this); });
		}

		onHover(menuItem) {
			if ($(window).width() >= 900)
				$(menuItem).children('.sub-menu').stop().fadeIn();
		}

		onHoverOut(menuItem) {
			if ($(window).width() >= 900)
				$(menuItem).children('.sub-menu').stop().fadeOut();
		}

	}

})(jQuery);


export default navInit;